import * as jQuery from 'jquery';
import * as _ from 'underscore';

import {
	AfterContentInit,
	AfterViewInit,
	ChangeDetectorRef,
	Component,
	ElementRef,
	Input,
	OnDestroy,
	OnInit,
	ViewChild
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NguCarousel, NguCarouselStore } from '@ngu/carousel';

import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { ColorConfig, DownloadConfig } from '../../../analytics-core/interfaces/widget.interface';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { ModalService } from '../../../shared/directives/modal/modal.service';
import { WidgetCore } from '../../interfaces/widget.core.interface';
import { CreativePerformance } from '../creative-detail-v2/creative-detail.interface';
import { CreativePerformanceV1Component } from '../creative-performace-v1/creative-performance-v1.component';

@Component({
	selector: 'app-display-creative-v3',
	styleUrls: ['./display-creative-v3.component.css'],
	templateUrl: './display-creative-v3.component.html'
})
export class DisplayCreativeV3Component
	extends CreativePerformanceV1Component
	implements OnInit, WidgetCore, AfterContentInit, AfterViewInit, OnDestroy
{
	@Input() key: string;
	@Input() sectiontitle: string;
	@Input() sectionclass: string;
	@Input() colors: string;
	@Input() colorsconfig: any;
	@Input() legend: any;
	@Input() placeholderimage: any;
	@ViewChild('carousel') carousel: NguCarousel<any>;
	@Input() removekeys: any;
	@Input() downloadconfig: string;
	@Input() downloadcsvcolumns: any;
	@Input() showalldatesdata: boolean;

	public svgWidth;
	public svgHeight = 200;
	public bubbleColor = 'rgba(142, 239, 236, 0.7)';
	public margin = { top: 10, right: 10, bottom: 10, left: 10 };
	public selectedLegend;
	public carouselToken: string;
	public removeKeysData;
	public iframeUrl;
	public downloadConfiguration: DownloadConfig;
	public downloadCSVColumns: any;

	@ViewChild('bubblechartcontainer', { static: true }) bubbleChartContainer: ElementRef;

	public graphSeriesData = [];
	public selectedCreative: CreativePerformance;

	constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected modalService: ModalService,
		protected cdr: ChangeDetectorRef,
		protected sanitizer: DomSanitizer
	) {
		super(analyticsService, colorUtilityService, analyticsDataModel, cdr, modalService);
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe(() => {
			jQuery('#display-creative-v3-chart-container').animate(
				{
					scrollTop: 0
				},
				100
			);
		});
	}

	ngOnInit(): void {
		super.ngOnInit();
		this.downloadConfiguration = JSON.parse(decodeURI(this.downloadconfig));
		this.downloadCSVColumns = JSON.parse(decodeURI(this.downloadcsvcolumns));
		this.removeKeysData = JSON.parse(decodeURI(this.removekeys));
		this.showalldatesdata = this.showalldatesdata.toString() === 'true' ? true : false;
		this.includeEngagements = true;
	}

	ngAfterViewInit(): void {
		this.cdr.detectChanges();
	}

	ngAfterContentInit(): void {
		this.svgWidth = jQuery(this.bubbleChartContainer.nativeElement).width() - 40;
	}

	ngOnDestroy(): void {
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
		this.selectedCreative = undefined;
	}

	initDataFn(event: NguCarouselStore): void {
		this.carouselToken = event.token;
	}

	resetFn(): void {
		if (this.carousel) {
			this.carousel.reset();
		}
	}

	processResponseData(responseData: any): void {
		this.graphSeriesData = [];
		if (responseData.length > 0) {
			this.hasData = true;

			this.creatives = this.mapResponseDataToInterface(responseData);
			if (this.removeKeysData.length > 0) {
				this.creatives = this.creatives.map((creative) => {
					for (const key of this.removeKeysData) {
						creative[key] = '';
					}
					return creative;
				});
			}
			const videoCreatives = _.where(this.creatives, { isVideoCreative: true });
			this.isVideoCreative = videoCreatives.length > 0;
			const selectedLegend: any = _.findWhere(this.legend, { selected: true });
			this.selectedLegend = selectedLegend;
			this.graphData = this.generateGraphDataBySelection(selectedLegend.value);
			this.processGraphDataForSeries();
			this.hasGraphData = true;
		} else {
			this.hasData = false;
		}
	}

	sortCreativesBySelection(selectionItem: string): any[] {
		const sortedCreatives = _.sortBy(this.creatives, selectionItem);
		return sortedCreatives;
	}

	processGraphDataForSeries(): void {
		this.graphData.series.forEach((series, index) => {
			this.graphSeriesData.push({
				categories: this.graphData.categories,
				id: `creative_id_${index}`,
				series: [series]
			});
		});

		this.showLoad = false;
	}

	processSelectedLegendItem(legendItem: any): void {
		this.showLoad = true;
		this.selectedLegend = legendItem;
		this.graphSeriesData = [];
		for (const legendObj of this.legend) {
			legendObj.selected = false;
		}
		const selectedLegend: any = _.findWhere(this.legend, { value: legendItem.value });
		selectedLegend.selected = true;
		this.graphData = this.generateGraphDataByUserSelection(selectedLegend.value);
		this.processGraphDataForSeries();
	}

	openModal(id: string, creative: CreativePerformance): void {
		this.modalService.open(id);
		if (!this.selectedCreative) {
			this.selectedCreative = creative;
		}
	}

	closeModal(id: string): void {
		this.selectedCreative = undefined;
		this.modalService.close(id);
	}

	onmoveFn(event: any): void {
		const elementId = `#display-creative_${event.currentSlide}`;
		if (elementId) {
			const parentDiv = jQuery('#display-creative-v3-chart-container');
			parentDiv.animate(
				{
					scrollTop: parentDiv.scrollTop() + jQuery(elementId).position().top
				},
				100
			);
		}
	}

	downloadCSV(e: any): void {
		e.preventDefault();
		this.analyticsService.downloadCSV(
			this.downloadConfiguration.csvQueryKey,
			this.downloadConfiguration.fileName,
			this.downloadCSVColumns
		);
	}

	getCreativeSize(thumbnail: string): string {
		if (
			thumbnail?.includes('728x90') ||
			thumbnail?.includes('468x60') ||
			thumbnail?.includes('320x50') ||
			thumbnail?.includes('300x50')
		) {
			return '100% 30%';
		} else if (thumbnail?.includes('300x600')) {
			return '75% 100%';
		} else if (thumbnail?.includes('160x600')) {
			return '40% 100%';
		} else {
			return '100% 100%';
		}
	}

	protected generateGraphDataByUserSelection(selectionItem: any): any {
		this.sortedCreatives = this.sortCreativesBySelection(selectionItem);
		const series = [];
		let length = this.sortedCreatives.length;
		for (let i = 0; i < this.sortedCreatives.length; i++) {
			const seriesObj: any = {};
			seriesObj['name'] = this.sortedCreatives[i].creativeName;
			seriesObj['id'] = this.sortedCreatives[i].versionId;
			seriesObj['data'] = this.sortedCreatives[i].graphData[selectionItem];
			seriesObj['color'] = this.getColorFromColorConfig(i, 1);
			this.sortedCreatives[i].color = seriesObj['color'];
			seriesObj['zIndex'] = length;
			series.push(seriesObj);
			length--;
		}
		const categories = this.sortedCreatives.length > 0 ? this.sortedCreatives[0].graphData.dates : [];
		const graphData = { series, categories };
		return graphData;
	}

	protected getColorFromColorConfig(index: number, opacity?: number): string {
		const availableColorsLength = _.values(this.colorsconfig).length;
		switch (this.selectedLegend.value) {
			case 'impressions':
				// tslint:disable-next-line: no-parameter-reassignment
				index = 0;
				break;
			case 'clicks':
				// tslint:disable-next-line: no-parameter-reassignment
				index = 1;
				break;
			case 'adInteractions':
				// tslint:disable-next-line: no-parameter-reassignment
				index = 2;
			case 'engagements':
				// tslint:disable-next-line: no-parameter-reassignment
				index = 2;
		}
		const colorIndex = index % availableColorsLength;
		const colorConfig: ColorConfig = this.colorsconfig[colorIndex];
		const fillOpacity = opacity ? opacity : colorConfig.opacity;
		let rgb = '';
		if (colorConfig.isHex) {
			rgb = this.colorUtilityService.getRGBByOpacity(colorConfig.color, fillOpacity);
		} else {
			rgb = this.colorUtilityService.getRGBByColorType(this.colorPalette, colorConfig.color, fillOpacity);
		}
		return rgb;
	}

	getPercentage(percentage) {
		return { width: `${Math.floor(percentage)}%` };
	}
}
